export const FONT_BASE = {
  REGULAR: 'grilledcheese_btn',
  CSS: ['fonts.css'],
};

export const FONTS = {
  BOOT: [FONT_BASE],
  APP: [],
};
